function decodeHistoryLog(log, replacers, convertMinutes = false) {
  let newLog = log
  for (const i of replacers) {
    const matcher = new RegExp(`${i.key}{.+?}`, 'g')
    let matchs = [...new Set((newLog.match(matcher) || []).map(i => i.substring(2, i.length - 1)))]
    for (const m of matchs) {
      if (convertMinutes && i.key === 'f' && m === 'minutes') {
        // x 為數字
        // 把 f{modify} f{minutes} [x] -> [x] 換算成 [h小時m分] -> [h小時m分]
        // 例如 f{modify} f{minutes} [30] -> [60] 改成 [30分] -> [1小時]
        // f{modify} f{minutes} [30] -> [90] 改成 [30分] -> [1小時30分]
        // 分鐘數 -> "h小時m分"
        const formatMinutes = (value) => {
          const total = Number(value)
          if (!Number.isFinite(total)) return value
          const sign = total < 0 ? '-' : ''
          const abs = Math.round(Math.abs(total))
          const h = Math.floor(abs / 60)
          const mm = abs % 60
          if (h && mm) return `${sign}${h}小時${mm}分`
          if (h) return `${sign}${h}小時`
          return `${sign}${mm}分`
        }

        // 找出 f{minutes} 後面連續的 [x]、-> [x] 片段
        const segmentMatcher = /(f\{minutes\})((?:\s*(?:->)?\s*\[-?\d+(?:\.\d+)?\])+)/g
        newLog = newLog.replace(segmentMatcher, (_, tag, values) =>
          tag + values.replace(/\[(-?\d+(?:\.\d+)?)\]/g, (__, num) => `[${formatMinutes(num)}]`)
        )
      }
      newLog = newLog.replace((new RegExp(`${i.key}{${m}}`, 'g')), i.replacer(m))
    }
  }
  return newLog
}

export {
  decodeHistoryLog,
};
